import { useEffect, useState, useCallback } from 'react'
import { debounce, suggest } from '../../lib/mapy'
import { mapMapyResult } from '../../lib/geo'

const DEBOUNCE_DELAY = 300

export const SMapSuggest = ({ query, children }) => {
  const [suggestions, setSuggestions] = useState([])
  const [loading, setLoading] = useState(false)

  const debouncedSuggest = useCallback(
    debounce(async (q) => {
      setLoading(true)
      try {
        const suggestions = await suggest(q)
        setSuggestions(suggestions.map(mapMapyResult))
      } finally {
        setLoading(false)
      }
    }, DEBOUNCE_DELAY),
    [],
  )

  useEffect(() => {
    if (query) {
      debouncedSuggest(query)
    }
  }, [query, debouncedSuggest])

  return children({ suggestions, loading })
}
